/* dev-product-slider.js */

function initAll() {
  document.querySelectorAll('.product-slider:not([data-slider-ready])').forEach(section => {
    section.setAttribute('data-slider-ready', '');
    init(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (e) => {
  const slider = e.target.querySelector('.product-slider');
  if (slider && !slider.hasAttribute('data-slider-ready')) {
    slider.setAttribute('data-slider-ready', '');
    init(slider);
  }
});

function init(section) {
  const track = section.querySelector('[data-slider-track]');
  const slides = section.querySelectorAll('[data-slide]');
  const prevBtn = section.querySelector('[data-slider-prev]');
  const nextBtn = section.querySelector('[data-slider-next]');
  const progressFill = section.querySelector('[data-slider-progress]');

  if (!track || slides.length < 2) return;

  let current = 0;
  const total = slides.length;

  function getSlideWidth() {
    const gap = parseFloat(getComputedStyle(track).gap) || 20;
    return slides[0].offsetWidth + gap;
  }

  function getSlidesPerView() {
    const w = window.innerWidth;
    if (w >= 1024) return 3;
    if (w >= 768) return 2;
    return 1;
  }

  function getMaxIndex() {
    return Math.max(0, total - getSlidesPerView());
  }

  function updateProgress() {
    if (!progressFill) return;
    const pct = ((current + getSlidesPerView()) / total) * 100;
    progressFill.style.width = `${Math.min(100, pct)}%`;
  }

  function goTo(index) {
    const max = getMaxIndex();
    current = Math.max(0, Math.min(index, max));
    track.style.transform = `translateX(-${current * getSlideWidth()}px)`;

    const isFirst = current === 0;
    const isLast = current >= max;

    if (prevBtn) {
      prevBtn.disabled = isFirst;
      prevBtn.dataset.state = isFirst ? 'inactive' : 'active';
    }
    if (nextBtn) {
      nextBtn.disabled = isLast;
      nextBtn.dataset.state = isLast ? 'inactive' : 'active';
    }

    updateProgress();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  // Touch swipe
  let startX = 0;
  let startY = 0;
  let isDragging = false;

  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
  }, { passive: true });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    const deltaX = startX - e.changedTouches[0].clientX;
    const deltaY = startY - e.changedTouches[0].clientY;
    isDragging = false;
    // ignore vertical scrolls
    if (Math.abs(deltaY) > Math.abs(deltaX)) return;
    if (Math.abs(deltaX) > 50) goTo(deltaX > 0 ? current + 1 : current - 1);
  }, { passive: true });

  // Recalculate on resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => goTo(Math.min(current, getMaxIndex())), 150);
  });

  goTo(0);
}
